import React from "react";
import { doctorProfileFiles } from "../../../../Util/API Calls/APIList";
import "./style.scss";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";

const DoctorContactsNew = ({
  id,
  name,
  initials,
  email,
  dr_phone_no,
  selected,
  handleCheckDoctorContacts,
  profile_picture_url,
  dr_first_name,
}) => {
  return (
    // <>

    <div className="contact-container">
      <input
        id={id}
        type={"checkbox"}
        onClick={handleCheckDoctorContacts}
        className={"d-none"}
        checked={selected}
        key={id}
        value={id}
      />
      <div className="d-flex my-3">
        <label htmlFor={id} className="no-image m-0 mr-3">
          {" "}
          {/**profile-picture */}
          {selected ? (
            <p className="m-0 initials">
              {" "}
              <CheckOutlinedIcon />
            </p>
          ) : profile_picture_url !== "" ? (
            <img
              className={
                profile_picture_url !== "" ? "profile-picture" : "no-image"
              }
              src={profile_picture_url}
              alt=""
            />
          ) : (
            <p className="initials m-0">{dr_first_name?.charAt(0)}</p>
          )}
        </label>
        <div className="name-container">
          <label
            htmlFor={id}
            className={"d-flex align-items-center m-0 flex-column"}
          >
            <p className="m-0 dr-name">{name}</p>
          </label>
          <p className="m-0">
            <small>{dr_phone_no}</small>
          </p>
        </div>
        {/* <label
          htmlFor={id}
          className={"d-flex align-items-center m-0 flex-column"}
        >
          <p className="m-0">{name}</p>
        </label> */}
      </div>
    </div>

    // </>
  );
};

export default DoctorContactsNew;
